export const ALERT_TYPES = {
    SUCCESS: 'ALERT_SUCCESS',
    ERROR: 'ALERT_ERROR',
    INFO: 'ALERT_INFO',
    CLEAR: 'ALERT_CLEAR',
    SET_ALERT_PROGRESS: 'SET_ALERT_PROGRESS'
};
